module.exports = __webpack_public_path__ + "img/randy-barias-untitled.b845223.jpg";